<script>
  export default {
    props: {
      isDisabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      tag: {
        type: String,
        required: false,
        default: 'button',
      },
    },

    computed: {
      disabledClass: (vm) => (vm.isDisabled ? 'disabled' : null),
    },
  };
</script>

<template>
  <component
    :is="tag"
    :class="['add-btn list-group-item', disabledClass]"
    v-on="$listeners"
    :disabled="isDisabled"
  >
    <span class="text-success fas fa-plus-circle mr-5"></span>
    <span><slot></slot></span>
  </component>
</template>

<style lang="scss" scoped>
  .add-btn {
    border: 1px dashed #afafaf;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .disabled {
    span {
      color: grey !important;
    }
  }
</style>
